import Heading from "../../components/layout/Heading";
import LightBlueEye from "../../components/assets/eyes/LightBlueEye";
import YellowEye from "../../components/assets/eyes/YellowEye";
import WorksImagesSwiper from "../../components/layout/WorksImagesSwiper";
import Works from "../Works";
import WorksCaroussel from "../WorksCaroussel";
import MosaicsLine from "../../components/layout/MosaicsLine";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "../../components/assets/Loader";
import axios from "axios";
import { BASE_URL, decodeHtmlEntities, stripHtmlTags, wrapParagraphs } from "../../globals";
import clsx from "clsx";
export default function Work() {
    const navigate = useNavigate();

    async function fetchData() {
        setIsLoading(true);
        const post_type = "realisation";
        try {
            const response = await axios.get(`${BASE_URL}/${post_type}?slug=${realisation}`);
            if (response.data.length < 1) {
                navigate("/realisations");
            } else {
                const responseData = response.data[0];
                const realisationData = {
                    id: responseData.id,
                    slug: responseData.slug,
                    title: decodeHtmlEntities(responseData.title.rendered),
                    excerpt: stripHtmlTags(responseData.excerpt ? responseData.excerpt.rendered : ""),
                    ...responseData.acf,
                    services: responseData.service
                }

                if (realisationData.services.length > 0) {
                    const taxonomy = "service";
                    const taxonomyData = await axios.get(`${BASE_URL}/${taxonomy}/${realisationData.services[0]}`);
                    realisationData.service = {
                        slug: taxonomyData.data.slug,
                        name: decodeHtmlEntities(taxonomyData.data.name)
                    };
                }
                const images_data = [];
                for (let media_id of realisationData.images) {
                    const mediaData = await axios.get(`${BASE_URL}/media/${media_id}`);
                    images_data.push(
                        {
                            src: mediaData.data.source_url,
                            alt: mediaData.data.alt_text
                        }
                    )
                }
                realisationData.images_data = images_data;
                if (realisationData.liens_externes) {
                    for (let lien_externe of realisationData.liens_externes) {
                        const mediaData = await axios.get(`${BASE_URL}/media/${lien_externe.image}`);
                        lien_externe.image = mediaData.data.source_url;
                    }
                }
                setData(realisationData);
            }
        } catch (err) {
            console.log(err)
        }
        setIsLoading(false);
    }

    const { realisation } = useParams();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, [realisation])

    return (
        <>
            {isLoading ? <div className="flex justify-center items-center py-16">
                <Loader />
            </div> : <>
                <div className="flex justify-center items-center gap-[0.5rem] text-zoeil-greyer mt-16">
                    <Link to={"/realisations"} className="underline transition-all hover:text-zoeil-blue">
                        Réalisations
                    </Link>
                    <span>&gt;</span>
                    {data.service &&
                        <>
                            <Link to={`/services/${data.service.slug}`} className="underline transition-all hover:text-zoeil-blue">
                                {data.service.name}
                            </Link>
                            <span>
                                &gt;
                            </span>
                        </>}
                    <Link to={`/realisations/${data.slug}`} className="underline transition-all hover:text-zoeil-blue">
                        {data.title}
                    </Link>
                </div>
                <div className="w-full max-w-[1470px] mx-auto min-h-[390px] flex flex-col justify-center mobile:px-8">
                    <div className="w-full relative py-16 mobile:py-32">
                        <Heading
                            title={data.title}
                            subtitle={data.excerpt}
                        />
                        <div className="w-[6.25rem] absolute right-0 top-0 -rotate-[150deg]">
                            <YellowEye version={2} />
                        </div>
                        <div className="w-[6.25rem] absolute left-0 bottom-0 -scale-y-[1] -rotate-[20deg]">
                            <LightBlueEye version={3} />
                        </div>
                    </div>
                </div>
                <div className="max-w-[1650px] flex justify-center items-center overflow-hidden w-full mx-auto px-8 tablet:flex-col tablet:gap-16">
                    <div className="basis-1/2 overflow-hidden tablet:max-w-[500px] tablet:w-full">
                        <div className="w-full aspect-[6/5] max-w-[700px] p-10">
                            <WorksImagesSwiper
                                images={data.images_data} />
                        </div>
                    </div>
                    <div className="basis-1/2 flex flex-col gap-[2.5rem]">
                        <h2 className="text-heading-2 font-bold leading-[100%] mobile:text-heading-3">
                            {data.accroche}
                        </h2>
                        <div className="flex flex-col gap-3" dangerouslySetInnerHTML={
                            {
                                __html: wrapParagraphs(data.description)
                            }
                        }>

                        </div>
                    </div>
                </div>
                <div className="flex justify-center items-center gap-[6.875rem] my-24">
                    {data.liens_externes && data.liens_externes.map((lien_externe, index) =>
                        <a href={lien_externe.lien_externe.url} target={lien_externe.lien_externe.target} className="block w-fit">
                            <div className={clsx(
                                "flex items-center gap-[1rem] justify-center min-w-[300px] text-white text-heading-5 font-bold px-6 [&:hover>*]:opacity-70",
                                index === 0 && "bg-zoeil-blue",
                                index === 1 && "bg-zoeil-yellow",
                                index === 2 && "bg-zoeil-pink"
                            )
                            }>
                                <div className="transition-all">
                                    {lien_externe.lien_externe.title}
                                </div>
                                <img src={lien_externe.image} aria-hidden className="w-[2rem] aspect-square object-contain transition-all" />
                            </div>
                        </a>
                    )}
                </div>
            </>}
            <div className="py-32">
                <WorksCaroussel />
            </div>
            <MosaicsLine />
        </>
    )
}